import {
  initApp3Success,
  initApp3ReadyServer,
  app3Offline,
  reconnect3Success,
  runEffect3Success,
  dispatchEvent3Success,
  loadLocale3Success,
  loadConfiguration3Success,
  loadView3Success,
  loadForm3Success,
  loadForm3Fail,
  changeStatus3Success,
  login3Success,
  login3Failed,
  pub3,
  closeForm3,
  reconnect3,
  streamUpload3Success,
  removeUpload3Success,
  initUpload3Success,
  setUserPersistentProfile,
  setValidationError,
  setForm3Section,
  setValidationMessage,
  incForm3Section,
  updateUserAttributes,
  error,
  warning,
  addNote3,
  loadHTMLTemplate3Success,
  pubsub3FormDataUpdate,
  loginSession,
  loginMetadata,
  resumeTicket,
  setPageTitle,
  signSession,
  setAppModalContent,
  socketDisconnect,
} from "../actions";
import { push, replace } from "connected-react-router";
import { addSocketHandler } from "../socket";

const eventHandlers = () => {
  addSocketHandler(null, "error", (res) => {
    return error(res);
  });

  addSocketHandler(null, "warning", (res) => {
    return warning(res);
  });

  // handle sessionId for login/collect methods
  addSocketHandler(null, "login3/collect", (session) => {
    return loginSession(session);
  });

  addSocketHandler(null, "login3/metadata", (props) => {
    return loginMetadata(props);
  });

  addSocketHandler(null, "sign/collect", (session) => {
    return signSession(session);
  });

  addSocketHandler(null, "sign/failed", (session) => {
    return signSession(session);
  });

  addSocketHandler(null, "connected", () => {
    app3Offline({ isOffline: false });
    return initApp3ReadyServer({});
  });

  addSocketHandler(null, "connect", () => {
    return app3Offline({ isOffline: false });
  });

  addSocketHandler(window.API_URL, "disconnect", () => {
    return socketDisconnect();
  });

  // connect2 is an experimental function to see if it helps
  // unwanted logouts on portal
  addSocketHandler(null, "connect2", () => {
    const jwt = localStorage.getItem("_jwt");
    if (jwt) {
      return reconnect3({ token: jwt });
    }
  });

  addSocketHandler(null, "reconnect3", (res) => {
    return reconnect3Success({
      userName: res.username,
      userID: res.userid,
      roles: res.roles,
      url: res.url,
      orgId: res.orgId,
      orgName: res.orgName,
      orgColor: res.orgColor,
      configuration: res.configuration,
      permissions: res.permissions,
      user: {},
      theme: res.theme,
      themes: res.themes,
      defaultBuilderRoles: res.defaultBuilderRoles,
      userPersistentProfile: res.userPersistentProfile,
    });
  });

  addSocketHandler(null, "login/failed", (res) => {
    return login3Failed({
      errorMsg: res.message ? res.message : "Login failed",
    });
  });

  /**
   * This is issued when we have an illegal/non-valid token. Then we drop the token from localStorage and proceed as anonymous
   */
  addSocketHandler(null, "dropToken", () => {
    localStorage.removeItem("_jwt");
    return initApp3Success({});
  });

  addSocketHandler(null, "initApp3Success", () => {
    return initApp3Success({});
  });

  addSocketHandler(null, "htmlTemplates", (templates) => {
    return loadHTMLTemplate3Success(templates);
  });

  // open up a new tab
  addSocketHandler(null, "_blank", (res) => {
    window.open(res, "_blank").focus();
  });

  // First or second argument can be callback function for acknowledgement,
  // depending on how the server emitted the event.
  addSocketHandler(null, "redirect", (res, addOriginURLOrAck, maybeAck) => {
    const addOriginURL =
      typeof addOriginURLOrAck === "function" ? false : addOriginURLOrAck;
    const ack =
      typeof addOriginURLOrAck === "function" ? addOriginURLOrAck : maybeAck;

    if (typeof ack === "function") {
      ack({ received: true });
    }

    if (!res) {
      // no url was supplied, ignore this request
      return;
    }

    if (res.startsWith("http") || res.startsWith("bankid")) {
      window.location = res;
    } else {
      // check for query params
      const splitURL = res.split("?");

      let search = splitURL[1] ? "?" + splitURL[1] : "";

      if (addOriginURL) {
        if (search) {
          search += "&";
        }

        search += `redirectedFrom=${encodeURIComponent(
          `${window.location.pathname?.replace("/", "")}${
            window.location.search || ""
          }`
        )}`;
      }

      return push({
        pathname: splitURL[0],
        search,
      });
    }
  });

  addSocketHandler(null, "hardRedirect", (res) => {
    if (!res) {
      // no url was supplied, ignore this request
      return;
    }

    window.location.assign(`${window.location.origin + res}`);
  });

  addSocketHandler(null, "reloadPage", () => {
    window.location.reload();
  });

  addSocketHandler(null, "reconnect3Success", () => {
    return reconnect3Success({});
  });

  addSocketHandler(null, "user", (res) => {
    return login3Success({
      userName: res.username,
      user: res,
      userPersistentProfile: res.userPersistentProfile,
    });
  });

  /** update user attribues. emitted when attributes are changed from server, such as QID */
  addSocketHandler(null, "user_update", (res) => {
    return updateUserAttributes(res);
  });

  addSocketHandler(null, "userPersistentProfile", (res) => {
    return setUserPersistentProfile(res, true);
  });

  addSocketHandler(null, "lang/get", (res) => {
    return loadLocale3Success(res.data);
  });

  addSocketHandler(null, "portal/loadConfiguration3", (res) => {
    return loadConfiguration3Success(res.data);
  });

  addSocketHandler(null, "portal/loadPublicConfiguration3", (res) => {
    return loadConfiguration3Success(res.data);
  });

  addSocketHandler(null, "portal/loadView3", (res) => {
    return loadView3Success(res.data);
  });

  addSocketHandler(null, "portal/changeStatus3", (res) => {
    return [changeStatus3Success(res.data), setForm3Section({ index: 0 })];
  });

  addSocketHandler(null, "portal/loadForm3", (res) => {
    if (res.data) {
      return loadForm3Success(res.data);
    } else {
      return loadForm3Fail({ err: res.err });
    }
  });

  addSocketHandler(null, "router/replace", (res) => {
    return replace(res.url);
  });

  addSocketHandler(null, "router/push", (res) => {
    return push(res.url);
  });

  addSocketHandler(null, "form3/close", () => {
    return closeForm3({});
  });

  addSocketHandler(null, "form3/validationError", (res) => {
    const { key, results } = res;
    return setValidationError({ key, results });
  });

  addSocketHandler(null, "form3/changeActiveSection", (res) => {
    const { key, results } = res;
    return setValidationError({ key, results });
  });

  addSocketHandler(null, "form3/setActiveSection", (res) => {
    const { index, direction } = res;
    return setForm3Section({ index, direction });
  });

  // used for login components to increase one section
  addSocketHandler(null, "form3/nextSection", () => {
    return incForm3Section({});
  });

  addSocketHandler(null, "form3/validationMessage", (res) => {
    const { type, message, heading, validationErrorMessages } = res;
    return setValidationMessage({
      type,
      message,
      heading,
      validationErrorMessages,
    });
  });

  addSocketHandler(null, "portal/initUpload3", (res) => {
    return initUpload3Success({ ...res });
  });

  addSocketHandler(null, "portal/streamUpload3", (res) => {
    return streamUpload3Success({ chunkId: res.chunkId, assetId: res.assetId });
  });

  addSocketHandler(null, "portal/removeUpload3", (res) => {
    return removeUpload3Success({ assetId: res.assetId });
  });

  addSocketHandler(null, "refresh-jwt", (token) => {
    if (token) {
      localStorage.setItem("_jwt", token);
    }
    return;
  });

  addSocketHandler(null, "jwt", (token) => {
    if (token) {
      localStorage.setItem("_jwt", token);
    }

    return reconnect3({ token });
  });

  addSocketHandler(null, "runEffect3", (res) => {
    const { data } = res;

    if (!data) {
      return;
    }

    const [_data, _errors, _warnings] = data;

    let _actions = [];

    if (_warnings) {
      const __warnings = !Array.isArray(_warnings) ? [_warnings] : _warnings;
      _actions = __warnings.map((w) => {
        return warning(w);
      });
    }

    if (_errors) {
      const __errors = !Array.isArray(_errors) ? [_errors] : _errors;
      _actions = __errors.map((w) => {
        return error(w);
      });
    }

    _actions.push(runEffect3Success({ data: _data, effectId: res._id }));

    return _actions;
  });

  addSocketHandler(null, "portal/dispatchEvent3", (res) => {
    const { data, _id } = res;

    const [_data, _errors, _warnings] = data;

    let _actions = [];

    if (_warnings) {
      const __warnings = !Array.isArray(_warnings) ? [_warnings] : _warnings;
      _actions = __warnings.map((w) => {
        return warning(w);
      });
    }

    if (_errors) {
      const __errors = !Array.isArray(_errors) ? [_errors] : _errors;
      _actions = __errors.map((w) => {
        return error(w);
      });
    }

    _actions.push(dispatchEvent3Success({ data: _data, _id }));

    return _actions;
  });

  addSocketHandler(null, "resumeTicket", (res) => {
    const { currentFormDataId, formDataId, removeActiveTicket } = res;

    return resumeTicket({ currentFormDataId, formDataId, removeActiveTicket });
  });

  addSocketHandler(null, "portal/setPageTitle", (res) => {
    const { pageTitle } = res;
    return setPageTitle({ pageTitle });
  });

  addSocketHandler(null, "setAppModalContent", (res) => {
    return setAppModalContent(res);
  });

  /**
   * PUBSUB: start
   */
  addSocketHandler(null, "pub", (res) => {
    switch (res.channel) {
      case "notification": {
        const { channel = "default", msg = "No message", id } = res;
        return pub3({ channel, msg, id });
      }
      case "ewsUpdate":
      case "eventBookingUpdate": {
        const { channel = "default", msg, id } = res;
        return pub3({ channel, msg, id });
      }
    }

    switch (res.type) {
      case "chat": {
        break;
      }
      case "dirty":
        break;
      case "pub": {
        const { channel = "default", message = {} } = res;

        switch (message.type) {
          case "save": {
            const { key, value, data } = message;
            return pubsub3FormDataUpdate({
              formDataId: channel,
              key,
              value,
              data,
            });
          }
          case "chat": {
            const { payload = {} } = message;
            const {
              noteId,
              note,
              formDataId,
              createdBy,
              createdByRole,
              created,
            } = payload;
            return addNote3({
              noSaga: true,
              formDataId,
              noteType: "external",
              noteId,
              note,
              origin: "admin",
              createdBy,
              createdByRole,
              created,
            });
          }
        }

        return pub3({ channel, msg: message });
      }
      default:
        break;
    }
  });
};

export default eventHandlers;
